import { useMemo } from 'react'
import { Modal } from 'react-bootstrap'
import { diff } from '../model/diff'
import type { AdapterRow } from '../model/types'

interface Props {
  show: boolean
  onClose: () => void
  before: AdapterRow[]
  after: AdapterRow[]
  saving: boolean
  onConfirm: () => void
}

/**
 * Diff-before-save confirmation (Экран B). Shows per-adapter rank / enabled /
 * range / traffic changes so the operator confirms exactly what is written.
 * Save persists via postAdapterPriorities (array order == priority).
 */
export const SaveDialog = ({ show, onClose, before, after, saving, onConfirm }: Props) => {
  const entries = useMemo(() => diff(before, after), [before, after])

  return (
    <Modal show={show} onHide={onClose} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Сохранить конфигурацию маршрутизации</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {entries.length === 0 ? (
          <div className='text-gray-600'>Изменений нет — сохранять нечего.</div>
        ) : (
          <>
            <div className='text-gray-700 fw-semibold mb-3'>
              Будут записаны следующие изменения ({entries.length}). Порядок строк = приоритет.
            </div>
            <div className='table-responsive'>
              <table className='table table-row-dashed align-middle gy-2'>
                <thead>
                  <tr className='fw-bold text-gray-600 fs-7 text-uppercase'>
                    <th>Адаптер</th>
                    <th>Изменения</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map((e) => (
                    <tr key={e.adapterId}>
                      <td className='fw-semibold text-gray-900'>{e.name}</td>
                      <td>
                        <div className='d-flex flex-wrap gap-2'>
                          {e.changes.map((c, i) => (
                            <span key={i} className='badge badge-light-primary'>
                              {c}
                            </span>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-light' onClick={onClose} disabled={saving}>
          Отмена
        </button>
        <button
          type='button'
          className='btn btn-success'
          onClick={onConfirm}
          disabled={saving || entries.length === 0}
        >
          {saving ? 'Сохраняем…' : 'Сохранить'}
        </button>
      </Modal.Footer>
    </Modal>
  )
}
